import { Typography } from '@mui/material';

import { Container, ContentContainer, ContentLeftContainer, ContentLeftTextContainer } from './styled';

import { ReactComponent as EthereumIcon } from 'src/assets/svg/Ethereum.svg';

export default function NetworkBadge() {
  return (
    <Container>
      <ContentContainer>
        <ContentLeftContainer>
          <EthereumIcon />
          <ContentLeftTextContainer>
            <Typography variant="h8">Mainnet</Typography>
          </ContentLeftTextContainer>
        </ContentLeftContainer>
      </ContentContainer>
    </Container>
  );
}
